import React, {useState, useEffect} from 'react';
import { useMediaQuery } from 'react-responsive'


function DigitalClick(){


    //const isDesktopOrLaptop = useMediaQuery({query: '(min-width: 1224px)'})
    //const isBigScreen = useMediaQuery({ query: '(min-width: 1824px)' })
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
    //const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
    //const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' })


    const [time, setTime] = useState(new Date());
    let lastDay = new Date(2036,11,29,12,0,0,0)

    useEffect(() => {
        const intervalId = setInterval(() => {
            setTime(new Date());
        },1000);
        
        return () => {
            clearInterval(intervalId);
        }
    },[]);

    function millisecondsLeft(){
        return (Math.floor( (lastDay - time )));
    }

    function formatTime(){

        let milisec = millisecondsLeft();

        let total_sec = parseInt(Math.floor(milisec / 1000));
        let total_min = parseInt(Math.floor(total_sec / 60));
        let total_hour = parseInt(Math.floor(total_min / 60));
        let days = parseInt(Math.floor(total_hour / 24))
        //let hours =  time.getHours();
        //const minutes = time.getMinutes();
        //const seconds = time.getSeconds();
        const seconds = parseInt(total_sec % 60);
        const minutes = parseInt(total_min % 60);
        let hours =  parseInt(total_hour % 24);
        return `${days}:${padZero(hours)}:${padZero(minutes)}:${padZero(seconds)}`;

    }

    function padZero(number){
        return (number < 10 ? "0" : "") + number
    }

    return(
    <div className='clock-container'>
        <div className={!isTabletOrMobile ? 'clock' : 'clock_Mobil'}>
            <span>Retirement in</span>
        </div>
       
        <div className={!isTabletOrMobile ? 'clock' : 'clock_Mobil'}>
            <span>{formatTime()}</span>
        </div>
    </div>)
}

export default DigitalClick;